import LogoWhite from './LogoWhite.svg';
import LogoBlack from './Logo-proga.svg';
import CustomEmptyImage from './CustomEmptyImage.svg';
import NoDBImage from './NoDBImage.svg';
import Frame1 from './Frame1.png';
import Frame2 from './Frame2.png';
import Frame3 from './Frame3.png';
import Frame0 from './Frame0.png';
import Frame5 from './Frame5.png';
import GirlPicture from './girlPicture.png';
import MiskLogo from './MiskLogo.svg';

export const Logos = {
    LogoWhite,
    LogoBlack,
    CustomEmptyImage,
    NoDBImage,
    Frame0,
    Frame1,
    Frame2,
    Frame3,
    Frame5,
    GirlPicture,
    MiskLogo,
};
